module.exports = __webpack_public_path__ + "html/mari-smith-tutorials_397c71b95b41cf647b60291b37f7f5c1.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/mari-smith-tutorials.html
// module id = wL/W
// module chunks = 36